export default "__VITE_ASSET__CZ5QC$6a__"